<template>
  <v-app>
    <app-bar @toggle-drawer="showDrawer = !showDrawer">
      <template v-slot:walletConnect>
        <div v-if="isLoggined == false">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="bright--text"
                icon
                depressed
                @click="wallect_connect"
                v-bind="attrs"
                v-on="on"
              >
                <img
                  src="@/assets/wallet-connect-logo.svg"
                  alt="Icon"
                  width="32"
                  height="32"
                />
              </v-btn>
            </template>
            <span>wallet-connect</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:loginButton>
        <div v-if="isLoggined">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="bright--text mr-3"
                icon
                depressed
                @click="logout"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-logout</v-icon>
              </v-btn>
            </template>
            <span>logout</span>
          </v-tooltip>
        </div>
        <div v-else>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="bright--text mr-3"
                icon
                depressed
                @click="login"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-login</v-icon>
              </v-btn>
            </template>
            <span>login</span>
          </v-tooltip>
        </div>
      </template>
    </app-bar>

    <nav-menu
      v-on:drawerWatch="updateChildDrawer"
      :value="showDrawer"
      :menulist="menulist"
    />

    <v-main v-if="isLoggined">
      <div class="pa-5">
        <router-view />
      </div>
    </v-main>

    <v-snackbar
      v-model="$store.state.toast.show"
      :color="$store.state.toast.color"
      :timeout="$store.state.toast.timeout"
      top
      right
    >
      {{ $store.state.toast.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="$store.commit('toast/HIDE_TOAST')">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="loginDialog" hide-overlay persistent width="320">
      <v-card color="primary" dark>
        <v-card-text class="pa-5">
          <div class="text-center mb-3">
            <v-icon size="40" color="white">mdi-wallet-outline</v-icon>
          </div>
          <div class="text-center white--text mb-2">연결 중입니다</div>
          <div class="text-center white--text text-body-2 mb-3">
            로그인 메시지에 서명해주세요
          </div>
          <v-progress-linear
            indeterminate
            color="white"
            class="mt-3"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import AppBar from '@/components/Application/AppBar.vue'
import NavMenu from '@/components/Application/NavMenu.vue'

import { Buffer } from 'buffer'
import api from '@/utils/api'

// @ts-ignore
window.Buffer = Buffer

import { configureChains, createConfig } from '@wagmi/core'
import { bsc, mainnet } from '@wagmi/core/chains'
import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum'
import { Web3Modal } from '@web3modal/html'
import { getAccount, signMessage, disconnect } from '@wagmi/core'

const projectId = process.env.VUE_APP_WEB3MODAL_PROJECT_ID

export default {
  name: 'App',

  components: { AppBar, NavMenu },

  data: () => ({
    showDrawer: true,
    chainId: '',
    loginDialog: false,
    jwt: null,
    menulist: [],
  }),
  watch: {
    showDrawer(/* oldValue, newValue */) {},
  },
  computed: {
    loading() {
      return this.$store.getters.loading
    },
    isLoggined() {
      return this.$store.getters['auth/isLoggined']
    },
    address() {
      return this.$store.getters['auth/address']
    },
  },
  methods: {
    updateChildDrawer(value) {
      this.showDrawer = value
    },
    async logginCallback(status) {
      if (status) {
        const { data } = await api.get('/menu/list', null, { silent: true })
        if (data) {
          this.menulist = (data.list || []).map((item) => item.route)
        }

        this.$store.dispatch('auth/checkLoginStatus')
      }
    },
    async login() {
      await window.ethereum.request({
        method: 'wallet_requestPermissions',
        params: [
          {
            eth_accounts: {},
          },
        ],
      })
      const accounts = await window.ethereum.request({
        method: 'eth_requestAccounts',
      })
      const address = accounts[0]

      // 보안 강화: nonce와 timestamp 추가 (Replay Attack 방지)
      const timestamp = Date.now()
      const nonce = Math.random().toString(36).substring(2, 15)
      const message = `Sign to authenticate with TMS.\n\nAddress: ${address}\nTimestamp: ${timestamp}\nNonce: ${nonce}`

      // Sign the message using MetaMask
      const signedMessage = await window.ethereum.request({
        method: 'personal_sign',
        params: [message, address],
      })

      this.$store.dispatch('auth/login', {
        address,
        message,
        signature: signedMessage,
        callback: this.logginCallback,
      })
    },
    async logout() {
      await this.$store.dispatch('auth/logout', {
        connector: this.connector,
      })

      // Only try to disconnect wagmi if it was used (wallet connect)
      // MetaMask doesn't use wagmi, so this may fail - that's OK
      try {
        await disconnect()
      } catch (error) {
        // Ignore wagmi disconnect errors (e.g., when using MetaMask)
      }
      window.location.reload()
    },
    async wallect_connect() {
      localStorage.clear()

      // 1. Define constants
      const chains = [bsc, mainnet]

      // 2. Configure wagmi client
      const { publicClient } = configureChains(chains, [
        w3mProvider({ projectId }),
      ])
      const wagmiConfig = createConfig({
        autoConnect: true,
        connectors: w3mConnectors({ chains, version: 1, projectId }),
        publicClient,
      })

      // 3. Create ethereum and modal clients
      const ethereumClient = new EthereumClient(wagmiConfig, chains)
      const web3Modal = new Web3Modal(
        {
          projectId,
          walletConnectVersion: 2,
          // walletImages: {
          //   safe: "https://pbs.twimg.com/profile_images/1566773491764023297/IvmCdGnM_400x400.jpg",
          // },
        },
        ethereumClient
      )

      if (getAccount().status != 'connected') {
        await web3Modal.openModal()
        let unsubscribe = undefined
        try {
          await new Promise((resolve, reject) => {
            unsubscribe = web3Modal.subscribeModal((newState) => {
              if (!newState.open) {
                resolve()
              } else {
                reject()
              }
            })
          })
          unsubscribe()
        } catch (error) {
          return
        }

        if (getAccount().connector == undefined) {
          await disconnect()
          return
        }
      }

      const address = getAccount().address

      // 보안 강화: nonce와 timestamp 추가 (Replay Attack 방지)
      const timestamp = Date.now()
      const nonce = Math.random().toString(36).substring(2, 15)
      const message = `Sign to authenticate with TMS.\n\nAddress: ${address}\nTimestamp: ${timestamp}\nNonce: ${nonce}`

      try {
        const signedMessage = await signMessage({ message })
        this.$store.dispatch('auth/login', {
          address,
          message,
          signature: signedMessage,
          callback: this.logginCallback,
        })
      } catch (error) {
        await disconnect()
        this.$toast.error('The connection has been cancelled')
      }
    },
  },
  async created() {
    const vuetifyTheme = localStorage.getItem('vuetifyTheme')
      ? JSON.parse(localStorage.getItem('vuetifyTheme'))
      : null
    if (vuetifyTheme == null) {
      localStorage.setItem(
        'vuetifyTheme',
        JSON.stringify({ dark: this.$vuetify.theme.dark })
      )
    } else {
      this.$vuetify.theme.dark = vuetifyTheme.dark
    }
  },
  async mounted() {
    await this.$store.dispatch('auth/checkLoginStatus')
    if (this.isLoggined) {
      this.logginCallback(true)
    }
  },
}
</script>

<style lang="scss">
/* Transitions */
.bounce-transition {
  &-enter-active,
  &-leave,
  &-leave-to {
    transition: all 0.2s ease;
  }
  &-enter,
  &-leave-to {
    transform: translateY(100px);
    opacity: 0;
  }
}

/* WalletConnect Modal */
.walletconnect-modal__base {
  max-width: 300px !important;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(12px) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
}
.walletconnect-modal__mobile__toggle {
  width: 100% !important;
}
.walletconnect-qrcode__text {
  font-size: 14px !important;
}

/* Data Table */
.v-data-table__wrapper {
  overflow-x: auto !important;
}
.v-application .v-data-table {
  &.outlined {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 12px;
  }
  table {
    table-layout: fixed;
    td,
    th {
      text-align: left !important;
      padding: 0 12px !important;
      word-break: break-word;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    th {
      font-weight: 600 !important;
      font-size: 12px !important;
      color: #546e7a !important;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      &.sortable .v-data-table-header__icon {
        position: absolute;
        color: #546e7a;
      }
    }
    td {
      text-align: left !important;
    }
    .v-input--checkbox .v-input__slot {
      justify-content: space-around;
      .v-input--selection-controls__input {
        margin: 0;
      }
    }
    .left {
      text-align: left !important;
    }
    .right {
      text-align: right !important;
    }
  }
}

.theme--dark .v-application .v-data-table {
  table th {
    color: #b0bec5 !important;
    &.sortable .v-data-table-header__icon {
      color: #b0bec5;
    }
  }
}

/* Input Fields */
.v-input {
  .theme--dark.v-label {
    color: #b0bec5 !important;
  }
}
.primary--text .v-input__control > .v-input__slot:after {
  border-color: rgba(84, 110, 122, 0.5) !important;
}
.v-application .primary {
  background: #37474f !important;
  color: #fff;
}

/* Cards */
.v-card {
  .col {
    padding: 0 12px !important;
    &:first-child {
      padding-top: 12px !important;
    }
  }
  .v-card__actions > .v-btn.v-btn {
    min-width: 85px;
    border-radius: 6px;
  }
}

/* Overlay */
.theme--dark .v-overlay__scrim {
  background-color: rgba(0, 0, 0, 0.6) !important;
}
.theme--light .v-overlay__scrim {
  background-color: rgba(0, 0, 0, 0.4) !important;
}
.theme--light.v-card > .v-card__text,
.theme--light.v-card > .v-card__subtitle {
  color: rgba(0, 0, 0, 0.87) !important;
}
.theme--dark.v-card > .v-card__text,
.theme--dark.v-card > .v-card__subtitle {
  color: rgba(255, 255, 255, 0.87) !important;
}

@media (max-width: 1263px) {
  h1 {
    font-size: 24px;
  }
}

/* Action Buttons */
.v-data-table td .v-btn.v-btn--has-bg.link-btn {
  background: none;
  box-shadow: unset;
}

/* Hover Area */
.hover_area {
  height: inherit;
  position: relative;
  line-height: 48px;
  max-width: 99%;
  .hover_address {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
  }
  .hover_inner {
    transition: all 0.2s ease;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    line-height: 48px;
    text-align: center;
    button {
      transition: all 0.2s ease;
      box-shadow: none;
      min-width: auto !important;
      padding: 0 !important;
      width: 32px !important;
      height: 32px !important;
      margin: 0 2px;
      border-radius: 6px;
      i {
        font-size: 14px;
      }
      &.edit {
        border: 1px solid #43a047;
        background: #fff !important;
        color: #43a047;
        &:hover {
          background: #43a047 !important;
          color: #fff !important;
        }
      }
      &.copy {
        border: 1px solid #546e7a;
        background: #fff !important;
        color: #546e7a;
        &:hover {
          background: #546e7a !important;
          color: #fff !important;
        }
      }
      &.link {
        border: 1px solid #e53935;
        background: #fff !important;
        color: #e53935;
        &:hover {
          background: #e53935 !important;
          color: #fff !important;
        }
      }
    }
  }
  &:hover .hover_inner {
    opacity: 1;
  }
}

/* Link Button */
.link-btn {
  border: 1px solid #e53935;
  background: #fff !important;
  color: #e53935 !important;
  width: 32px !important;
  height: 32px !important;
  margin: 0;
  border-radius: 6px;
  min-width: auto !important;
  transition: all 0.2s ease;
}
.link-btn i {
  font-size: 14px !important;
}
.link-btn:hover {
  background: #e53935 !important;
  color: #fff !important;
}

/* Select */
.v-select__selections input[readonly] {
  line-height: 0;
  font-size: 0;
  padding: 0;
}

/* Selected Row */
.v-data-table tr.select-tr {
  background: rgba(55, 71, 79, 0.1) !important;
}
.theme--dark.v-data-table tr.select-tr {
  background: rgba(255, 255, 255, 0.08) !important;
}

/* Labels */
.v-input .theme--dark.v-label {
  color: #b0bec5 !important;
}

/* Search Row */
.search_row .v-text-field__details {
  display: none !important;
}

/* Button Row */
.btn-row {
  display: flex;
  gap: 8px;
}
.btn-row > button {
  margin: 8px 0;
  border-radius: 6px;
}

/* Menu Content */
.theme--light .v-menu__content {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
}
.theme--dark .v-menu__content {
  background: rgba(38, 38, 38, 0.95) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
}

/* Login Dialog */
.v-dialog {
  .v-card.primary {
    background: #37474f !important;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
  }
}
</style>
